import { Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { Params } from '@angular/router';
import { IPaginatedResponse } from '../typing/response.interface';
import { ILabelValue } from '../ui-lib/common-dropdawn/typing/label-value.interface';
import { PriceService } from './price.service';
import { IPrice } from '../typing/price.interface';

@Injectable({
    providedIn: 'root'
})
export class PriceSelectorService {

    constructor(private priceService: PriceService) {
    }

    getList(query: Params): Observable<IPaginatedResponse<ILabelValue>> {
        return this.priceService.getList(query).pipe(map(response => this.transformData(response)));
    }

    transformData(paginatedResponse: IPaginatedResponse<IPrice>): IPaginatedResponse<ILabelValue> {
        const transformedData = paginatedResponse.data.map(price => {
            return {
                label: `${price.work.name} ${price.category?.name ?? ''}`,
                value: price.id,
                tooltip: this.getTooltip(price),
            };
        });

        return {
            ...paginatedResponse,
            data: transformedData,
        } as IPaginatedResponse<ILabelValue>;
    }

    getOptionsByValue(optionValue: number | string): Observable<ILabelValue> {
        return this.priceService.getPrice(Number(optionValue)).pipe(
            filter(price => !!price),
            map(price => ({
                label: `${price.work.name} ${price.category.name}` as string,
                value: price.id as number,
                tooltip: '---',
            })),
        );
    }

    getTooltip(value: IPrice): string {
        return (value.id ? value.id : '') + (value.id ? '; id:' + value.id : '') ;
    }

}
